<template>
	<div id="home">
		<NavComponet/>
		<SideMenuComponent/>
		<HomeComponent/>
	</div>
</template>

<script>
import NavComponet from '@/components/common/NavComponent.vue'
import SideMenuComponent from '@/components/common/SideMenuComponent.vue'
import HomeComponent from '@/components/admin/AdminComponent.vue';

// import axios from 'axios'

export default {
  name: 'HomeView',
	components: {
		NavComponet,
		SideMenuComponent,
		HomeComponent
	}
}
</script>

<style scoped>
.router-link-active{
  padding-left: 0;
}
</style>

